import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../store/context/notification-context";

const AuthExpiredHandler = () => {
  const { triggerNotification } = useNotification();
  const navigate = useNavigate();
  const shownRef = useRef(false);

  useEffect(() => {
    const onAuthExpired = (ev) => {
      if (shownRef.current) return; // ensure single instance
      shownRef.current = true;

      const message = ev?.detail?.message || "Your session has expired. You will be logged out.";
      const providedRoute = ev?.detail?.loginRoute;

      triggerNotification({
        type: "error",
        message: "Session expired",
        description: message,
        duration: 8,
        statusCode: 401,
        showAuth: true,
      });

      // clear session and redirect after a short delay so user sees the notification
      setTimeout(() => {
        try {
          // adjust to your auth/session clearing logic
          localStorage.clear();
          sessionStorage.clear();
        } catch (e) { /* ignore */ }
        // send user to login (use navigate or location replace)
         const target = providedRoute || "/authentication/login";
    
        try { navigate(target, { replace: true }); } catch { window.location.href = "/login"; }
      }, 1200);
    };

    window.addEventListener("auth:expired", onAuthExpired);
    return () => window.removeEventListener("auth:expired", onAuthExpired);
  }, [triggerNotification, navigate]);

  return null;
};

export default AuthExpiredHandler;